/* istanbul ignore file */
import React from 'react';
import Select, { components, InputProps } from 'react-select';
import { DropdownLayoutProps, Option, OptionsGroup } from 'ui-builder';

import useUiTheme from '../../../uibuilder/uiTheme';

import './DropdownLayout.scss';
import CreatableSelect from 'react-select/creatable';
import useFeatureToggleService from 'feature-toggle';
import ShadcnDropdownLayout from '../../../uibuilder/form/input/layout/ShadcnDropdownLayout';

function Input({ ...rest }: InputProps) {
  return (<components.Input {...rest} autoComplete="nope" />);
}

function LegacyDropdownLayout(props: DropdownLayoutProps) {
  const uiTheme = useUiTheme();

  const areOptionsGrouped = () => {
    return props.options && props.options?.length > 0 && Array.isArray(props.options[0].options);
  };

  const getCurrentValue = () => {
    if (areOptionsGrouped()) {
      let result;
      (props.options as OptionsGroup[])
        .forEach((group) => {
          group.options.forEach((option) => {
            if (option.value === props.value) {
              result = option;
            }
          });
        });
      return result;
    } else {
      return (props.options as Option[])
        .find((option) => option.value === props.value) || undefined;
    }
  };

  const isClearable = props.isClearable !== undefined ? props.isClearable : true;


  const Widget = props.optionCreateFunc ? CreatableSelect : Select;

  return (
    <uiTheme.forms.BaseInputLayout
      name={props.name}
      errors={props.errors}
      hint={props.hint}
      label={props.label}
      className={`${props.className || ''}${props.theme || ''}`}
      hideLabel={props.hideLabel}
      showRequiredIcon={props.showRequiredIcon}
    >
      <Widget
        name={props.name}
        className={`nekst-dropdown ${props.theme || ''}`}
        classNamePrefix="nekst-dropdown"
        options={props.options}
        isClearable={isClearable}
        value={getCurrentValue() || ''}
        placeholder={props.placeholder}
        isDisabled={props.isDisabled}
        onChange={(newValue: any) => {
          props.onChangeCallback({
            target: {
              value: newValue ? newValue.value : null,
            },
          });
        }}
        onCreateOption={props.optionCreateFunc}
        onInputChange={(newValue) => props.onInputChange?.(newValue)}
        components={{
          IndicatorSeparator: () => null,
          // @ts-ignore
          Input,
        }}
        formatOptionLabel={(data) => {
          return data.labelWidget || data.label;
        }}
        data-testid={`${props.name}-dropdown`}
        data-test={`${props.name}-dropdown`}
      />
    </uiTheme.forms.BaseInputLayout>
  );
}

function DropdownLayout(props: DropdownLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnDropdownLayout {...props} />;
  } else {
    return <LegacyDropdownLayout {...props} />;
  }
}

export default DropdownLayout;
